import paymentClient from './paymentClient'
import type { WalletSummary } from '../model/types'

export async function getWalletSummary(): Promise<WalletSummary> {
  const response = await paymentClient.get('/v1/user/wallet')
  const data = response.data?.data
  return {
    credit_balance: Number(data?.credit_balance) || 0,
    bonus_balance: Number(data?.bonus_balance) || 0,
    referred_by: typeof data?.referred_by === 'string' ? data.referred_by : null,
    referred_by_email_masked: typeof data?.referred_by_email_masked === 'string' ? data.referred_by_email_masked : null,
  }
}
